/**
 * Parses current url and returns Cloud Tenant name.
 *
 * Also handles OPS Portal tenants name from url.
 *
 * e.g. "test.openvpn-stable.com" -> "test"
 *
 * e.g. OPS: "opsportal.openvpn-qa.com/cloud-tenant-configuration/test-ops/status" -> "test-ops"
 */
export function getTenant() {
    const tenant = window.location.hostname.split('.')[0];
    if (tenant === 'opsportal') {
        return window.location.pathname.split('/')[2];
    }
    return tenant;
}
